import React from 'react';
import {formatDuration, formatCartElementDate} from "../../utils/dateTimeUtils";
import CartElementConfirmation from "./CartElementConfirmation";
import { useLingui } from '@lingui/react/macro';

function CartExcursionEntryConfirmation(props) {

    const {t} = useLingui();

    const implodePassengers = () => {
        return props.excursion.passengers.map(passenger => `${passenger.firstName} ${passenger.lastName}`).join(", ");
    };

    const excursion = props.excursion;

    return (
        <CartElementConfirmation
            title={excursion.excursionName}
            subtitle={`${excursion.portName?.toUpperCase()}, ${excursion.portCountry?.toUpperCase()}`}
            day={`${t({id: "on_day"})} ${excursion.dayNr} (${formatCartElementDate(excursion.date)})`}
            time={`${t({id: "duration"})}: ${formatDuration(excursion.duration)}`}
            people={implodePassengers()}
            price={excursion.price}
            status={excursion.status}
            strikePrice={props.strikePrice}
        />
    )
}


export default CartExcursionEntryConfirmation;